/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Library_Sortbyplaceholder2Inputs */

const id_profile_library_sortbyplaceholder2 = /** @type {(inputs: Profile_Library_Sortbyplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Urutkan berdasarkan`)
};

const ms_profile_library_sortbyplaceholder2 = /** @type {(inputs: Profile_Library_Sortbyplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Susun mengikut`)
};

const da_profile_library_sortbyplaceholder2 = /** @type {(inputs: Profile_Library_Sortbyplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sorter efter`)
};

const de_profile_library_sortbyplaceholder2 = /** @type {(inputs: Profile_Library_Sortbyplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sortieren nach`)
};

const en_us2_profile_library_sortbyplaceholder2 = /** @type {(inputs: Profile_Library_Sortbyplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sort by`)
};

const es_es2_profile_library_sortbyplaceholder2 = /** @type {(inputs: Profile_Library_Sortbyplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordenar por`)
};

const es_mx2_profile_library_sortbyplaceholder2 = /** @type {(inputs: Profile_Library_Sortbyplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordenar por`)
};

const fil_profile_library_sortbyplaceholder2 = /** @type {(inputs: Profile_Library_Sortbyplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagbukud-bukurin ayon sa`)
};

const fr_profile_library_sortbyplaceholder2 = /** @type {(inputs: Profile_Library_Sortbyplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trier par`)
};

const it_profile_library_sortbyplaceholder2 = /** @type {(inputs: Profile_Library_Sortbyplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordina per`)
};

const hu_profile_library_sortbyplaceholder2 = /** @type {(inputs: Profile_Library_Sortbyplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rendezés`)
};

const nl_profile_library_sortbyplaceholder2 = /** @type {(inputs: Profile_Library_Sortbyplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sorteren op`)
};

const no_profile_library_sortbyplaceholder2 = /** @type {(inputs: Profile_Library_Sortbyplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sorter etter`)
};

const pl_profile_library_sortbyplaceholder2 = /** @type {(inputs: Profile_Library_Sortbyplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sortuj według`)
};

const pt_br2_profile_library_sortbyplaceholder2 = /** @type {(inputs: Profile_Library_Sortbyplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordenar por`)
};

const pt_profile_library_sortbyplaceholder2 = /** @type {(inputs: Profile_Library_Sortbyplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordenar por`)
};

const ro_profile_library_sortbyplaceholder2 = /** @type {(inputs: Profile_Library_Sortbyplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sortează după`)
};

const fi_profile_library_sortbyplaceholder2 = /** @type {(inputs: Profile_Library_Sortbyplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Järjestä`)
};

const sv_profile_library_sortbyplaceholder2 = /** @type {(inputs: Profile_Library_Sortbyplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sortera efter`)
};

const vi_profile_library_sortbyplaceholder2 = /** @type {(inputs: Profile_Library_Sortbyplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sắp xếp theo`)
};

const tr_profile_library_sortbyplaceholder2 = /** @type {(inputs: Profile_Library_Sortbyplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sırala`)
};

const cs_profile_library_sortbyplaceholder2 = /** @type {(inputs: Profile_Library_Sortbyplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seřadit podle`)
};

const bg_profile_library_sortbyplaceholder2 = /** @type {(inputs: Profile_Library_Sortbyplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сортиране по`)
};

const ru_profile_library_sortbyplaceholder2 = /** @type {(inputs: Profile_Library_Sortbyplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сортировать по`)
};

const uk_profile_library_sortbyplaceholder2 = /** @type {(inputs: Profile_Library_Sortbyplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сортувати за`)
};

const ar_profile_library_sortbyplaceholder2 = /** @type {(inputs: Profile_Library_Sortbyplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ترتيب حسب`)
};

const hi_profile_library_sortbyplaceholder2 = /** @type {(inputs: Profile_Library_Sortbyplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इसके अनुसार क्रमबद्ध करें`)
};

const th_profile_library_sortbyplaceholder2 = /** @type {(inputs: Profile_Library_Sortbyplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`จัดเรียงตาม`)
};

const ja_profile_library_sortbyplaceholder2 = /** @type {(inputs: Profile_Library_Sortbyplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`並び替え`)
};

const zh_cn2_profile_library_sortbyplaceholder2 = /** @type {(inputs: Profile_Library_Sortbyplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`排序方式`)
};

const zh_hant1_profile_library_sortbyplaceholder2 = /** @type {(inputs: Profile_Library_Sortbyplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`排序方式`)
};

const ko_profile_library_sortbyplaceholder2 = /** @type {(inputs: Profile_Library_Sortbyplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`정렬 기준`)
};

/**
* | output |
* | --- |
* | "Sort by" |
*
* @param {Profile_Library_Sortbyplaceholder2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_library_sortbyplaceholder2 = /** @type {((inputs?: Profile_Library_Sortbyplaceholder2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Library_Sortbyplaceholder2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_library_sortbyplaceholder2(inputs)
	if (locale === "ms") return ms_profile_library_sortbyplaceholder2(inputs)
	if (locale === "da") return da_profile_library_sortbyplaceholder2(inputs)
	if (locale === "de") return de_profile_library_sortbyplaceholder2(inputs)
	if (locale === "en-US") return en_us2_profile_library_sortbyplaceholder2(inputs)
	if (locale === "es-ES") return es_es2_profile_library_sortbyplaceholder2(inputs)
	if (locale === "es-MX") return es_mx2_profile_library_sortbyplaceholder2(inputs)
	if (locale === "fil") return fil_profile_library_sortbyplaceholder2(inputs)
	if (locale === "fr") return fr_profile_library_sortbyplaceholder2(inputs)
	if (locale === "it") return it_profile_library_sortbyplaceholder2(inputs)
	if (locale === "hu") return hu_profile_library_sortbyplaceholder2(inputs)
	if (locale === "nl") return nl_profile_library_sortbyplaceholder2(inputs)
	if (locale === "no") return no_profile_library_sortbyplaceholder2(inputs)
	if (locale === "pl") return pl_profile_library_sortbyplaceholder2(inputs)
	if (locale === "pt-BR") return pt_br2_profile_library_sortbyplaceholder2(inputs)
	if (locale === "pt") return pt_profile_library_sortbyplaceholder2(inputs)
	if (locale === "ro") return ro_profile_library_sortbyplaceholder2(inputs)
	if (locale === "fi") return fi_profile_library_sortbyplaceholder2(inputs)
	if (locale === "sv") return sv_profile_library_sortbyplaceholder2(inputs)
	if (locale === "vi") return vi_profile_library_sortbyplaceholder2(inputs)
	if (locale === "tr") return tr_profile_library_sortbyplaceholder2(inputs)
	if (locale === "cs") return cs_profile_library_sortbyplaceholder2(inputs)
	if (locale === "bg") return bg_profile_library_sortbyplaceholder2(inputs)
	if (locale === "ru") return ru_profile_library_sortbyplaceholder2(inputs)
	if (locale === "uk") return uk_profile_library_sortbyplaceholder2(inputs)
	if (locale === "ar") return ar_profile_library_sortbyplaceholder2(inputs)
	if (locale === "hi") return hi_profile_library_sortbyplaceholder2(inputs)
	if (locale === "th") return th_profile_library_sortbyplaceholder2(inputs)
	if (locale === "ja") return ja_profile_library_sortbyplaceholder2(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_library_sortbyplaceholder2(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_library_sortbyplaceholder2(inputs)
	return ko_profile_library_sortbyplaceholder2(inputs)
});
export { profile_library_sortbyplaceholder2 as "profile.library.sortByPlaceholder" }